/**
 * created by sunchenyao on 2020/12/17
 */

export const city = [{
    "label": "北京市",
    "value": "110000000000",
    "children": [{
        "province": "北京市",
        "label": "北京市",
        "value": "110100000000"
    }]
}, {
    "label": "天津市",
    "value": "120000000000",
    "children": [{
        "province": "天津市",
        "label": "天津市",
        "value": "120100000000"
    }]
}, {
    "label": "河北省",
    "value": "130000000000",
    "children": [{
        "province": "河北省",
        "label": "石家庄市",
        "value": "130100000000"
    }, {
        "province": "河北省",
        "label": "唐山市",
        "value": "130200000000"
    }, {
        "province": "河北省",
        "label": "秦皇岛市",
        "value": "130300000000"
    }, {
        "province": "河北省",
        "label": "邯郸市",
        "value": "130400000000"
    }, {
        "province": "河北省",
        "label": "邢台市",
        "value": "130500000000"
    }, {
        "province": "河北省",
        "label": "保定市",
        "value": "130600000000"
    }, {
        "province": "河北省",
        "label": "张家口市",
        "value": "130700000000"
    }, {
        "province": "河北省",
        "label": "承德市",
        "value": "130800000000"
    }, {
        "province": "河北省",
        "label": "沧州市",
        "value": "130900000000"
    }, {
        "province": "河北省",
        "label": "廊坊市",
        "value": "131000000000"
    }, {
        "province": "河北省",
        "label": "衡水市",
        "value": "131100000000"
    }]
}, {
    "label": "山西省",
    "value": "140000000000",
    "children": [{
        "province": "山西省",
        "label": "太原市",
        "value": "140100000000"
    }, {
        "province": "山西省",
        "label": "大同市",
        "value": "140200000000"
    }, {
        "province": "山西省",
        "label": "阳泉市",
        "value": "140300000000"
    }, {
        "province": "山西省",
        "label": "长治市",
        "value": "140400000000"
    }, {
        "province": "山西省",
        "label": "晋城市",
        "value": "140500000000"
    }, {
        "province": "山西省",
        "label": "朔州市",
        "value": "140600000000"
    }, {
        "province": "山西省",
        "label": "晋中市",
        "value": "140700000000"
    }, {
        "province": "山西省",
        "label": "运城市",
        "value": "140800000000"
    }, {
        "province": "山西省",
        "label": "忻州市",
        "value": "140900000000"
    }, {
        "province": "山西省",
        "label": "临汾市",
        "value": "141000000000"
    }, {
        "province": "山西省",
        "label": "吕梁市",
        "value": "141100000000"
    }]
}, {
    "label": "内蒙古自治区",
    "value": "150000000000",
    "children": [{
        "province": "内蒙古自治区",
        "label": "呼和浩特市",
        "value": "150100000000"
    }, {
        "province": "内蒙古自治区",
        "label": "包头市",
        "value": "150200000000"
    }, {
        "province": "内蒙古自治区",
        "label": "乌海市",
        "value": "150300000000"
    }, {
        "province": "内蒙古自治区",
        "label": "赤峰市",
        "value": "150400000000"
    }, {
        "province": "内蒙古自治区",
        "label": "通辽市",
        "value": "150500000000"
    }, {
        "province": "内蒙古自治区",
        "label": "鄂尔多斯市",
        "value": "150600000000"
    }, {
        "province": "内蒙古自治区",
        "label": "呼伦贝尔市",
        "value": "150700000000"
    }, {
        "province": "内蒙古自治区",
        "label": "巴彦淖尔市",
        "value": "150800000000"
    }, {
        "province": "内蒙古自治区",
        "label": "乌兰察布市",
        "value": "150900000000"
    }, {
        "province": "内蒙古自治区",
        "label": "兴安盟",
        "value": "152200000000"
    }, {
        "province": "内蒙古自治区",
        "label": "锡林郭勒盟",
        "value": "152500000000"
    }, {
        "province": "内蒙古自治区",
        "label": "阿拉善盟",
        "value": "152900000000"
    }]
}, {
    "label": "辽宁省",
    "value": "210000000000",
    "children": [{
        "province": "辽宁省",
        "label": "沈阳市",
        "value": "210100000000"
    }, {
        "province": "辽宁省",
        "label": "大连市",
        "value": "210200000000"
    }, {
        "province": "辽宁省",
        "label": "鞍山市",
        "value": "210300000000"
    }, {
        "province": "辽宁省",
        "label": "抚顺市",
        "value": "210400000000"
    }, {
        "province": "辽宁省",
        "label": "本溪市",
        "value": "210500000000"
    }, {
        "province": "辽宁省",
        "label": "丹东市",
        "value": "210600000000"
    }, {
        "province": "辽宁省",
        "label": "锦州市",
        "value": "210700000000"
    }, {
        "province": "辽宁省",
        "label": "营口市",
        "value": "210800000000"
    }, {
        "province": "辽宁省",
        "label": "阜新市",
        "value": "210900000000"
    }, {
        "province": "辽宁省",
        "label": "辽阳市",
        "value": "211000000000"
    }, {
        "province": "辽宁省",
        "label": "盘锦市",
        "value": "211100000000"
    }, {
        "province": "辽宁省",
        "label": "铁岭市",
        "value": "211200000000"
    }, {
        "province": "辽宁省",
        "label": "朝阳市",
        "value": "211300000000"
    }, {
        "province": "辽宁省",
        "label": "葫芦岛市",
        "value": "211400000000"
    }]
}, {
    "label": "吉林省",
    "value": "220000000000",
    "children": [{
        "province": "吉林省",
        "label": "长春市",
        "value": "220100000000"
    }, {
        "province": "吉林省",
        "label": "吉林市",
        "value": "220200000000"
    }, {
        "province": "吉林省",
        "label": "四平市",
        "value": "220300000000"
    }, {
        "province": "吉林省",
        "label": "辽源市",
        "value": "220400000000"
    }, {
        "province": "吉林省",
        "label": "通化市",
        "value": "220500000000"
    }, {
        "province": "吉林省",
        "label": "白山市",
        "value": "220600000000"
    }, {
        "province": "吉林省",
        "label": "松原市",
        "value": "220700000000"
    }, {
        "province": "吉林省",
        "label": "白城市",
        "value": "220800000000"
    }, {
        "province": "吉林省",
        "label": "延边朝鲜族自治州",
        "value": "222400000000"
    }]
}, {
    "label": "黑龙江省",
    "value": "230000000000",
    "children": [{
        "province": "黑龙江省",
        "label": "哈尔滨市",
        "value": "230100000000"
    }, {
        "province": "黑龙江省",
        "label": "齐齐哈尔市",
        "value": "230200000000"
    }, {
        "province": "黑龙江省",
        "label": "鸡西市",
        "value": "230300000000"
    }, {
        "province": "黑龙江省",
        "label": "鹤岗市",
        "value": "230400000000"
    }, {
        "province": "黑龙江省",
        "label": "双鸭山市",
        "value": "230500000000"
    }, {
        "province": "黑龙江省",
        "label": "大庆市",
        "value": "230600000000"
    }, {
        "province": "黑龙江省",
        "label": "伊春市",
        "value": "230700000000"
    }, {
        "province": "黑龙江省",
        "label": "佳木斯市",
        "value": "230800000000"
    }, {
        "province": "黑龙江省",
        "label": "七台河市",
        "value": "230900000000"
    }, {
        "province": "黑龙江省",
        "label": "牡丹江市",
        "value": "231000000000"
    }, {
        "province": "黑龙江省",
        "label": "黑河市",
        "value": "231100000000"
    }, {
        "province": "黑龙江省",
        "label": "绥化市",
        "value": "231200000000"
    }, {
        "province": "黑龙江省",
        "label": "大兴安岭地区",
        "value": "232700000000"
    }]
}, {
    "label": "上海市",
    "value": "310000000000",
    "children": [{
        "province": "上海市",
        "label": "上海市",
        "value": "310100000000"
    }]
}, {
    "label": "江苏省",
    "value": "320000000000",
    "children": [{
        "province": "江苏省",
        "label": "南京市",
        "value": "320100000000"
    }, {
        "province": "江苏省",
        "label": "无锡市",
        "value": "320200000000"
    }, {
        "province": "江苏省",
        "label": "徐州市",
        "value": "320300000000"
    }, {
        "province": "江苏省",
        "label": "常州市",
        "value": "320400000000"
    }, {
        "province": "江苏省",
        "label": "苏州市",
        "value": "320500000000"
    }, {
        "province": "江苏省",
        "label": "南通市",
        "value": "320600000000"
    }, {
        "province": "江苏省",
        "label": "连云港市",
        "value": "320700000000"
    }, {
        "province": "江苏省",
        "label": "淮安市",
        "value": "320800000000"
    }, {
        "province": "江苏省",
        "label": "盐城市",
        "value": "320900000000"
    }, {
        "province": "江苏省",
        "label": "扬州市",
        "value": "321000000000"
    }, {
        "province": "江苏省",
        "label": "镇江市",
        "value": "321100000000"
    }, {
        "province": "江苏省",
        "label": "泰州市",
        "value": "321200000000"
    }, {
        "province": "江苏省",
        "label": "宿迁市",
        "value": "321300000000"
    }]
}, {
    "label": "浙江省",
    "value": "330000000000",
    "children": [{
        "province": "浙江省",
        "label": "杭州市",
        "value": "330100000000"
    }, {
        "province": "浙江省",
        "label": "宁波市",
        "value": "330200000000"
    }, {
        "province": "浙江省",
        "label": "温州市",
        "value": "330300000000"
    }, {
        "province": "浙江省",
        "label": "嘉兴市",
        "value": "330400000000"
    }, {
        "province": "浙江省",
        "label": "湖州市",
        "value": "330500000000"
    }, {
        "province": "浙江省",
        "label": "绍兴市",
        "value": "330600000000"
    }, {
        "province": "浙江省",
        "label": "金华市",
        "value": "330700000000"
    }, {
        "province": "浙江省",
        "label": "衢州市",
        "value": "330800000000"
    }, {
        "province": "浙江省",
        "label": "舟山市",
        "value": "330900000000"
    }, {
        "province": "浙江省",
        "label": "台州市",
        "value": "331000000000"
    }, {
        "province": "浙江省",
        "label": "丽水市",
        "value": "331100000000"
    }]
}, {
    "label": "安徽省",
    "value": "340000000000",
    "children": [{
        "province": "安徽省",
        "label": "合肥市",
        "value": "340100000000"
    }, {
        "province": "安徽省",
        "label": "芜湖市",
        "value": "340200000000"
    }, {
        "province": "安徽省",
        "label": "蚌埠市",
        "value": "340300000000"
    }, {
        "province": "安徽省",
        "label": "淮南市",
        "value": "340400000000"
    }, {
        "province": "安徽省",
        "label": "马鞍山市",
        "value": "340500000000"
    }, {
        "province": "安徽省",
        "label": "淮北市",
        "value": "340600000000"
    }, {
        "province": "安徽省",
        "label": "铜陵市",
        "value": "340700000000"
    }, {
        "province": "安徽省",
        "label": "安庆市",
        "value": "340800000000"
    }, {
        "province": "安徽省",
        "label": "黄山市",
        "value": "341000000000"
    }, {
        "province": "安徽省",
        "label": "滁州市",
        "value": "341100000000"
    }, {
        "province": "安徽省",
        "label": "阜阳市",
        "value": "341200000000"
    }, {
        "province": "安徽省",
        "label": "宿州市",
        "value": "341300000000"
    }, {
        "province": "安徽省",
        "label": "六安市",
        "value": "341500000000"
    }, {
        "province": "安徽省",
        "label": "亳州市",
        "value": "341600000000"
    }, {
        "province": "安徽省",
        "label": "池州市",
        "value": "341700000000"
    }, {
        "province": "安徽省",
        "label": "宣城市",
        "value": "341800000000"
    }]
}, {
    "label": "福建省",
    "value": "350000000000",
    "children": [{
        "province": "福建省",
        "label": "福州市",
        "value": "350100000000"
    }, {
        "province": "福建省",
        "label": "厦门市",
        "value": "350200000000"
    }, {
        "province": "福建省",
        "label": "莆田市",
        "value": "350300000000"
    }, {
        "province": "福建省",
        "label": "三明市",
        "value": "350400000000"
    }, {
        "province": "福建省",
        "label": "泉州市",
        "value": "350500000000"
    }, {
        "province": "福建省",
        "label": "漳州市",
        "value": "350600000000"
    }, {
        "province": "福建省",
        "label": "南平市",
        "value": "350700000000"
    }, {
        "province": "福建省",
        "label": "龙岩市",
        "value": "350800000000"
    }, {
        "province": "福建省",
        "label": "宁德市",
        "value": "350900000000"
    }]
}, {
    "label": "江西省",
    "value": "360000000000",
    "children": [{
        "province": "江西省",
        "label": "南昌市",
        "value": "360100000000"
    }, {
        "province": "江西省",
        "label": "景德镇市",
        "value": "360200000000"
    }, {
        "province": "江西省",
        "label": "萍乡市",
        "value": "360300000000"
    }, {
        "province": "江西省",
        "label": "九江市",
        "value": "360400000000"
    }, {
        "province": "江西省",
        "label": "新余市",
        "value": "360500000000"
    }, {
        "province": "江西省",
        "label": "鹰潭市",
        "value": "360600000000"
    }, {
        "province": "江西省",
        "label": "赣州市",
        "value": "360700000000"
    }, {
        "province": "江西省",
        "label": "吉安市",
        "value": "360800000000"
    }, {
        "province": "江西省",
        "label": "宜春市",
        "value": "360900000000"
    }, {
        "province": "江西省",
        "label": "抚州市",
        "value": "361000000000"
    }, {
        "province": "江西省",
        "label": "上饶市",
        "value": "361100000000"
    }]
}, {
    "label": "山东省",
    "value": "370000000000",
    "children": [{
        "province": "山东省",
        "label": "济南市",
        "value": "370100000000"
    }, {
        "province": "山东省",
        "label": "青岛市",
        "value": "370200000000"
    }, {
        "province": "山东省",
        "label": "淄博市",
        "value": "370300000000"
    }, {
        "province": "山东省",
        "label": "枣庄市",
        "value": "370400000000"
    }, {
        "province": "山东省",
        "label": "东营市",
        "value": "370500000000"
    }, {
        "province": "山东省",
        "label": "烟台市",
        "value": "370600000000"
    }, {
        "province": "山东省",
        "label": "潍坊市",
        "value": "370700000000"
    }, {
        "province": "山东省",
        "label": "济宁市",
        "value": "370800000000"
    }, {
        "province": "山东省",
        "label": "泰安市",
        "value": "370900000000"
    }, {
        "province": "山东省",
        "label": "威海市",
        "value": "371000000000"
    }, {
        "province": "山东省",
        "label": "日照市",
        "value": "371100000000"
    }, {
        "province": "山东省",
        "label": "莱芜市",
        "value": "371200000000"
    }, {
        "province": "山东省",
        "label": "临沂市",
        "value": "371300000000"
    }, {
        "province": "山东省",
        "label": "德州市",
        "value": "371400000000"
    }, {
        "province": "山东省",
        "label": "聊城市",
        "value": "371500000000"
    }, {
        "province": "山东省",
        "label": "滨州市",
        "value": "371600000000"
    }, {
        "province": "山东省",
        "label": "菏泽市",
        "value": "371700000000"
    }]
}, {
    "label": "河南省",
    "value": "410000000000",
    "children": [{
        "province": "河南省",
        "label": "郑州市",
        "value": "410100000000"
    }, {
        "province": "河南省",
        "label": "开封市",
        "value": "410200000000"
    }, {
        "province": "河南省",
        "label": "洛阳市",
        "value": "410300000000"
    }, {
        "province": "河南省",
        "label": "平顶山市",
        "value": "410400000000"
    }, {
        "province": "河南省",
        "label": "安阳市",
        "value": "410500000000"
    }, {
        "province": "河南省",
        "label": "鹤壁市",
        "value": "410600000000"
    }, {
        "province": "河南省",
        "label": "新乡市",
        "value": "410700000000"
    }, {
        "province": "河南省",
        "label": "焦作市",
        "value": "410800000000"
    }, {
        "province": "河南省",
        "label": "濮阳市",
        "value": "410900000000"
    }, {
        "province": "河南省",
        "label": "许昌市",
        "value": "411000000000"
    }, {
        "province": "河南省",
        "label": "漯河市",
        "value": "411100000000"
    }, {
        "province": "河南省",
        "label": "三门峡市",
        "value": "411200000000"
    }, {
        "province": "河南省",
        "label": "南阳市",
        "value": "411300000000"
    }, {
        "province": "河南省",
        "label": "商丘市",
        "value": "411400000000"
    }, {
        "province": "河南省",
        "label": "信阳市",
        "value": "411500000000"
    }, {
        "province": "河南省",
        "label": "周口市",
        "value": "411600000000"
    }, {
        "province": "河南省",
        "label": "驻马店市",
        "value": "411700000000"
    }, {
        "province": "河南省",
        "label": "省直辖县级行政区划",
        "value": "419000000000"
    }]
}, {
    "label": "湖北省",
    "value": "420000000000",
    "children": [{
        "province": "湖北省",
        "label": "武汉市",
        "value": "420100000000"
    }, {
        "province": "湖北省",
        "label": "黄石市",
        "value": "420200000000"
    }, {
        "province": "湖北省",
        "label": "十堰市",
        "value": "420300000000"
    }, {
        "province": "湖北省",
        "label": "宜昌市",
        "value": "420500000000"
    }, {
        "province": "湖北省",
        "label": "襄阳市",
        "value": "420600000000"
    }, {
        "province": "湖北省",
        "label": "鄂州市",
        "value": "420700000000"
    }, {
        "province": "湖北省",
        "label": "荆门市",
        "value": "420800000000"
    }, {
        "province": "湖北省",
        "label": "孝感市",
        "value": "420900000000"
    }, {
        "province": "湖北省",
        "label": "荆州市",
        "value": "421000000000"
    }, {
        "province": "湖北省",
        "label": "黄冈市",
        "value": "421100000000"
    }, {
        "province": "湖北省",
        "label": "咸宁市",
        "value": "421200000000"
    }, {
        "province": "湖北省",
        "label": "随州市",
        "value": "421300000000"
    }, {
        "province": "湖北省",
        "label": "恩施土家族苗族自治州",
        "value": "422800000000"
    }, {
        "province": "湖北省",
        "label": "省直辖县级行政区划",
        "value": "429000000000"
    }]
}, {
    "label": "湖南省",
    "value": "430000000000",
    "children": [{
        "province": "湖南省",
        "label": "长沙市",
        "value": "430100000000"
    }, {
        "province": "湖南省",
        "label": "株洲市",
        "value": "430200000000"
    }, {
        "province": "湖南省",
        "label": "湘潭市",
        "value": "430300000000"
    }, {
        "province": "湖南省",
        "label": "衡阳市",
        "value": "430400000000"
    }, {
        "province": "湖南省",
        "label": "邵阳市",
        "value": "430500000000"
    }, {
        "province": "湖南省",
        "label": "岳阳市",
        "value": "430600000000"
    }, {
        "province": "湖南省",
        "label": "常德市",
        "value": "430700000000"
    }, {
        "province": "湖南省",
        "label": "张家界市",
        "value": "430800000000"
    }, {
        "province": "湖南省",
        "label": "益阳市",
        "value": "430900000000"
    }, {
        "province": "湖南省",
        "label": "郴州市",
        "value": "431000000000"
    }, {
        "province": "湖南省",
        "label": "永州市",
        "value": "431100000000"
    }, {
        "province": "湖南省",
        "label": "怀化市",
        "value": "431200000000"
    }, {
        "province": "湖南省",
        "label": "娄底市",
        "value": "431300000000"
    }, {
        "province": "湖南省",
        "label": "湘西土家族苗族自治州",
        "value": "433100000000"
    }]
}, {
    "label": "广东省",
    "value": "440000000000",
    "children": [{
        "province": "广东省",
        "label": "广州市",
        "value": "440100000000"
    }, {
        "province": "广东省",
        "label": "韶关市",
        "value": "440200000000"
    }, {
        "province": "广东省",
        "label": "深圳市",
        "value": "440300000000"
    }, {
        "province": "广东省",
        "label": "珠海市",
        "value": "440400000000"
    }, {
        "province": "广东省",
        "label": "汕头市",
        "value": "440500000000"
    }, {
        "province": "广东省",
        "label": "佛山市",
        "value": "440600000000"
    }, {
        "province": "广东省",
        "label": "江门市",
        "value": "440700000000"
    }, {
        "province": "广东省",
        "label": "湛江市",
        "value": "440800000000"
    }, {
        "province": "广东省",
        "label": "茂名市",
        "value": "440900000000"
    }, {
        "province": "广东省",
        "label": "肇庆市",
        "value": "441200000000"
    }, {
        "province": "广东省",
        "label": "惠州市",
        "value": "441300000000"
    }, {
        "province": "广东省",
        "label": "梅州市",
        "value": "441400000000"
    }, {
        "province": "广东省",
        "label": "汕尾市",
        "value": "441500000000"
    }, {
        "province": "广东省",
        "label": "河源市",
        "value": "441600000000"
    }, {
        "province": "广东省",
        "label": "阳江市",
        "value": "441700000000"
    }, {
        "province": "广东省",
        "label": "清远市",
        "value": "441800000000"
    }, {
        "province": "广东省",
        "label": "东莞市",
        "value": "441900000000"
    }, {
        "province": "广东省",
        "label": "中山市",
        "value": "442000000000"
    }, {
        "province": "广东省",
        "label": "潮州市",
        "value": "445100000000"
    }, {
        "province": "广东省",
        "label": "揭阳市",
        "value": "445200000000"
    }, {
        "province": "广东省",
        "label": "云浮市",
        "value": "445300000000"
    }]
}, {
    "label": "广西壮族自治区",
    "value": "450000000000",
    "children": [{
        "province": "广西壮族自治区",
        "label": "南宁市",
        "value": "450100000000"
    }, {
        "province": "广西壮族自治区",
        "label": "柳州市",
        "value": "450200000000"
    }, {
        "province": "广西壮族自治区",
        "label": "桂林市",
        "value": "450300000000"
    }, {
        "province": "广西壮族自治区",
        "label": "梧州市",
        "value": "450400000000"
    }, {
        "province": "广西壮族自治区",
        "label": "北海市",
        "value": "450500000000"
    }, {
        "province": "广西壮族自治区",
        "label": "防城港市",
        "value": "450600000000"
    }, {
        "province": "广西壮族自治区",
        "label": "钦州市",
        "value": "450700000000"
    }, {
        "province": "广西壮族自治区",
        "label": "贵港市",
        "value": "450800000000"
    }, {
        "province": "广西壮族自治区",
        "label": "玉林市",
        "value": "450900000000"
    }, {
        "province": "广西壮族自治区",
        "label": "百色市",
        "value": "451000000000"
    }, {
        "province": "广西壮族自治区",
        "label": "贺州市",
        "value": "451100000000"
    }, {
        "province": "广西壮族自治区",
        "label": "河池市",
        "value": "451200000000"
    }, {
        "province": "广西壮族自治区",
        "label": "来宾市",
        "value": "451300000000"
    }, {
        "province": "广西壮族自治区",
        "label": "崇左市",
        "value": "451400000000"
    }]
}, {
    "label": "海南省",
    "value": "460000000000",
    "children": [{
        "province": "海南省",
        "label": "海口市",
        "value": "460100000000"
    }, {
        "province": "海南省",
        "label": "三亚市",
        "value": "460200000000"
    }, {
        "province": "海南省",
        "label": "三沙市",
        "value": "460300000000"
    }, {
        "province": "海南省",
        "label": "儋州市",
        "value": "460400000000"
    }, {
        "province": "海南省",
        "label": "省直辖县级行政区划",
        "value": "469000000000"
    }]
}, {
    "label": "重庆市",
    "value": "500000000000",
    "children": [{
        "province": "重庆市",
        "label": "重庆市",
        "value": "500100000000"
    }]
}, {
    "label": "四川省",
    "value": "510000000000",
    "children": [{
        "province": "四川省",
        "label": "成都市",
        "value": "510100000000"
    }, {
        "province": "四川省",
        "label": "自贡市",
        "value": "510300000000"
    }, {
        "province": "四川省",
        "label": "攀枝花市",
        "value": "510400000000"
    }, {
        "province": "四川省",
        "label": "泸州市",
        "value": "510500000000"
    }, {
        "province": "四川省",
        "label": "德阳市",
        "value": "510600000000"
    }, {
        "province": "四川省",
        "label": "绵阳市",
        "value": "510700000000"
    }, {
        "province": "四川省",
        "label": "广元市",
        "value": "510800000000"
    }, {
        "province": "四川省",
        "label": "遂宁市",
        "value": "510900000000"
    }, {
        "province": "四川省",
        "label": "内江市",
        "value": "511000000000"
    }, {
        "province": "四川省",
        "label": "乐山市",
        "value": "511100000000"
    }, {
        "province": "四川省",
        "label": "南充市",
        "value": "511300000000"
    }, {
        "province": "四川省",
        "label": "眉山市",
        "value": "511400000000"
    }, {
        "province": "四川省",
        "label": "宜宾市",
        "value": "511500000000"
    }, {
        "province": "四川省",
        "label": "广安市",
        "value": "511600000000"
    }, {
        "province": "四川省",
        "label": "达州市",
        "value": "511700000000"
    }, {
        "province": "四川省",
        "label": "雅安市",
        "value": "511800000000"
    }, {
        "province": "四川省",
        "label": "巴中市",
        "value": "511900000000"
    }, {
        "province": "四川省",
        "label": "资阳市",
        "value": "512000000000"
    }, {
        "province": "四川省",
        "label": "阿坝藏族羌族自治州",
        "value": "513200000000"
    }, {
        "province": "四川省",
        "label": "甘孜藏族自治州",
        "value": "513300000000"
    }, {
        "province": "四川省",
        "label": "凉山彝族自治州",
        "value": "513400000000"
    }]
}, {
    "label": "贵州省",
    "value": "520000000000",
    "children": [{
        "province": "贵州省",
        "label": "贵阳市",
        "value": "520100000000"
    }, {
        "province": "贵州省",
        "label": "六盘水市",
        "value": "520200000000"
    }, {
        "province": "贵州省",
        "label": "遵义市",
        "value": "520300000000"
    }, {
        "province": "贵州省",
        "label": "安顺市",
        "value": "520400000000"
    }, {
        "province": "贵州省",
        "label": "毕节市",
        "value": "520500000000"
    }, {
        "province": "贵州省",
        "label": "铜仁市",
        "value": "520600000000"
    }, {
        "province": "贵州省",
        "label": "黔西南布依族苗族自治州",
        "value": "522300000000"
    }, {
        "province": "贵州省",
        "label": "黔东南苗族侗族自治州",
        "value": "522600000000"
    }, {
        "province": "贵州省",
        "label": "黔南布依族苗族自治州",
        "value": "522700000000"
    }]
}, {
    "label": "云南省",
    "value": "530000000000",
    "children": [{
        "province": "云南省",
        "label": "昆明市",
        "value": "530100000000"
    }, {
        "province": "云南省",
        "label": "曲靖市",
        "value": "530300000000"
    }, {
        "province": "云南省",
        "label": "玉溪市",
        "value": "530400000000"
    }, {
        "province": "云南省",
        "label": "保山市",
        "value": "530500000000"
    }, {
        "province": "云南省",
        "label": "昭通市",
        "value": "530600000000"
    }, {
        "province": "云南省",
        "label": "丽江市",
        "value": "530700000000"
    }, {
        "province": "云南省",
        "label": "普洱市",
        "value": "530800000000"
    }, {
        "province": "云南省",
        "label": "临沧市",
        "value": "530900000000"
    }, {
        "province": "云南省",
        "label": "楚雄彝族自治州",
        "value": "532300000000"
    }, {
        "province": "云南省",
        "label": "红河哈尼族彝族自治州",
        "value": "532500000000"
    }, {
        "province": "云南省",
        "label": "文山壮族苗族自治州",
        "value": "532600000000"
    }, {
        "province": "云南省",
        "label": "西双版纳傣族自治州",
        "value": "532800000000"
    }, {
        "province": "云南省",
        "label": "大理白族自治州",
        "value": "532900000000"
    }, {
        "province": "云南省",
        "label": "德宏傣族景颇族自治州",
        "value": "533100000000"
    }, {
        "province": "云南省",
        "label": "怒江傈僳族自治州",
        "value": "533300000000"
    }, {
        "province": "云南省",
        "label": "迪庆藏族自治州",
        "value": "533400000000"
    }]
}, {
    "label": "西藏自治区",
    "value": "540000000000",
    "children": [{
        "province": "西藏自治区",
        "label": "拉萨市",
        "value": "540100000000"
    }, {
        "province": "西藏自治区",
        "label": "日喀则市",
        "value": "540200000000"
    }, {
        "province": "西藏自治区",
        "label": "昌都市",
        "value": "540300000000"
    }, {
        "province": "西藏自治区",
        "label": "林芝市",
        "value": "540400000000"
    }, {
        "province": "西藏自治区",
        "label": "山南市",
        "value": "540500000000"
    }, {
        "province": "西藏自治区",
        "label": "那曲市",
        "value": "540600000000"
    }, {
        "province": "西藏自治区",
        "label": "阿里地区",
        "value": "542500000000"
    }]
}, {
    "label": "陕西省",
    "value": "610000000000",
    "children": [{
        "province": "陕西省",
        "label": "西安市",
        "value": "610100000000"
    }, {
        "province": "陕西省",
        "label": "铜川市",
        "value": "610200000000"
    }, {
        "province": "陕西省",
        "label": "宝鸡市",
        "value": "610300000000"
    }, {
        "province": "陕西省",
        "label": "咸阳市",
        "value": "610400000000"
    }, {
        "province": "陕西省",
        "label": "渭南市",
        "value": "610500000000"
    }, {
        "province": "陕西省",
        "label": "延安市",
        "value": "610600000000"
    }, {
        "province": "陕西省",
        "label": "汉中市",
        "value": "610700000000"
    }, {
        "province": "陕西省",
        "label": "榆林市",
        "value": "610800000000"
    }, {
        "province": "陕西省",
        "label": "安康市",
        "value": "610900000000"
    }, {
        "province": "陕西省",
        "label": "商洛市",
        "value": "611000000000"
    }]
}, {
    "label": "甘肃省",
    "value": "620000000000",
    "children": [{
        "province": "甘肃省",
        "label": "兰州市",
        "value": "620100000000"
    }, {
        "province": "甘肃省",
        "label": "嘉峪关市",
        "value": "620200000000"
    }, {
        "province": "甘肃省",
        "label": "金昌市",
        "value": "620300000000"
    }, {
        "province": "甘肃省",
        "label": "白银市",
        "value": "620400000000"
    }, {
        "province": "甘肃省",
        "label": "天水市",
        "value": "620500000000"
    }, {
        "province": "甘肃省",
        "label": "武威市",
        "value": "620600000000"
    }, {
        "province": "甘肃省",
        "label": "张掖市",
        "value": "620700000000"
    }, {
        "province": "甘肃省",
        "label": "平凉市",
        "value": "620800000000"
    }, {
        "province": "甘肃省",
        "label": "酒泉市",
        "value": "620900000000"
    }, {
        "province": "甘肃省",
        "label": "庆阳市",
        "value": "621000000000"
    }, {
        "province": "甘肃省",
        "label": "定西市",
        "value": "621100000000"
    }, {
        "province": "甘肃省",
        "label": "陇南市",
        "value": "621200000000"
    }, {
        "province": "甘肃省",
        "label": "临夏回族自治州",
        "value": "622900000000"
    }, {
        "province": "甘肃省",
        "label": "甘南藏族自治州",
        "value": "623000000000"
    }]
}, {
    "label": "青海省",
    "value": "630000000000",
    "children": [{
        "province": "青海省",
        "label": "西宁市",
        "value": "630100000000"
    }, {
        "province": "青海省",
        "label": "海东市",
        "value": "630200000000"
    }, {
        "province": "青海省",
        "label": "海北藏族自治州",
        "value": "632200000000"
    }, {
        "province": "青海省",
        "label": "黄南藏族自治州",
        "value": "632300000000"
    }, {
        "province": "青海省",
        "label": "海南藏族自治州",
        "value": "632500000000"
    }, {
        "province": "青海省",
        "label": "果洛藏族自治州",
        "value": "632600000000"
    }, {
        "province": "青海省",
        "label": "玉树藏族自治州",
        "value": "632700000000"
    }, {
        "province": "青海省",
        "label": "海西蒙古族藏族自治州",
        "value": "632800000000"
    }]
}, {
    "label": "宁夏回族自治区",
    "value": "640000000000",
    "children": [{
        "province": "宁夏回族自治区",
        "label": "银川市",
        "value": "640100000000"
    }, {
        "province": "宁夏回族自治区",
        "label": "石嘴山市",
        "value": "640200000000"
    }, {
        "province": "宁夏回族自治区",
        "label": "吴忠市",
        "value": "640300000000"
    }, {
        "province": "宁夏回族自治区",
        "label": "固原市",
        "value": "640400000000"
    }, {
        "province": "宁夏回族自治区",
        "label": "中卫市",
        "value": "640500000000"
    }]
}, {
    "label": "新疆维吾尔自治区",
    "value": "650000000000",
    "children": [{
        "province": "新疆维吾尔自治区",
        "label": "乌鲁木齐市",
        "value": "650100000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "克拉玛依市",
        "value": "650200000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "吐鲁番市",
        "value": "650400000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "哈密市",
        "value": "650500000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "昌吉回族自治州",
        "value": "652300000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "博尔塔拉蒙古自治州",
        "value": "652700000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "巴音郭楞蒙古自治州",
        "value": "652800000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "阿克苏地区",
        "value": "652900000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "克孜勒苏柯尔克孜自治州",
        "value": "653000000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "喀什地区",
        "value": "653100000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "和田地区",
        "value": "653200000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "伊犁哈萨克自治州",
        "value": "654000000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "塔城地区",
        "value": "654200000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "阿勒泰地区",
        "value": "654300000000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "自治区直辖县级行政区划",
        "value": "659000000000"
    }]
}]
